import React from 'react';
import NewActivityCard from '@alltrails/shared/components/ActivityCard';
import MapCard from '@alltrails/shared/components/MapCard';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useFeatures from 'hooks/useFeatures';
import { getActivityFromTrack, getMapFromTrack } from 'utils/cardInfo';
import Context from 'types/Context';
import { Track } from 'types/Trails';
import useActivityDuration from 'hooks/useActivityDuration';
import useAdminFooterCTAs, { ButtonConfig } from 'hooks/useAdminFooterCTAs';
import CustomProvider from 'components/CustomProvider';
import TrackHoverCard from '../TrackHoverCard';

type ActivityHoverCardProps = {
  track: Track;
  context: Context;
  handleCardClick: () => void;
  handleFavoriteClick: () => void;
  isFavorite?: boolean;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  bottomButtonsConfig?: ButtonConfig[];
  containerWidth?: number;
};

const ActivityHoverCard = ({
  track,
  context,
  handleCardClick,
  handleFavoriteClick,
  isFavorite,
  handleMouseEnter,
  handleMouseLeave,
  bottomButtonsConfig,
  containerWidth
}: ActivityHoverCardProps): JSX.Element => {
  const newMiniCards = useFeatures().includes('new_mini_cards');
  const languageRegionCode = useLanguageRegionCode();
  const minutes = useActivityDuration(track);
  const footerCTAs = useAdminFooterCTAs(bottomButtonsConfig);

  if (newMiniCards) {
    const card =
      track.type === 'map' ? (
        <MapCard
          languageRegionCode={languageRegionCode}
          onCardClick={handleCardClick}
          onCardMouseEnter={handleMouseEnter}
          onCardMouseLeave={handleMouseLeave}
          onFavoriteClick={handleFavoriteClick}
          isFavorite={isFavorite}
          variant="small"
          map={getMapFromTrack(track, minutes, languageRegionCode)}
          isFirstParty={context?.currentUser?.id === track.user?.id}
          useMetric={context?.displayMetric}
          footerCTAs={footerCTAs && footerCTAs.length ? footerCTAs : undefined}
        />
      ) : (
        <NewActivityCard
          languageRegionCode={languageRegionCode}
          onCardClick={handleCardClick}
          onCardMouseEnter={handleMouseEnter}
          onCardMouseLeave={handleMouseLeave}
          onFavoriteClick={handleFavoriteClick}
          isFavorite={isFavorite}
          variant="small"
          activity={getActivityFromTrack(track, minutes)}
          isFirstParty={context?.currentUser?.id === track.user?.id}
          useMetric={context?.displayMetric}
          footerCTAs={footerCTAs && footerCTAs.length ? footerCTAs : undefined}
        />
      );

    // TODO: TD-350 Remove CustomProvider
    return <CustomProvider>{card}</CustomProvider>;
  }

  return (
    <TrackHoverCard
      track={track}
      context={context}
      handleCardClick={handleCardClick}
      handleFavoriteClick={handleFavoriteClick}
      isFavorite={isFavorite}
      handleMouseEnter={handleMouseEnter}
      handleMouseLeave={handleMouseLeave}
      bottomButtonsConfig={bottomButtonsConfig}
      containerWidth={containerWidth}
    />
  );
};

export default ActivityHoverCard;
